import { Breadcrumb, Button, Card, Checkbox, Col, message, Row } from "antd";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NavLink, useParams } from "react-router-dom";
import { useNotify } from "../../../../components/Notification";
import { permissionAPIWithErrorHandling } from "../../../../api/admin/permission";

const AddPermissionInUser = () => {
  const { id } = useParams();
  const notify = useNotify();
  const [isLoading, setIsLoading] = useState(false);
  const [listPermission, setListPermission] = useState([]);
  const [dataDetail, setDataDetail] = useState();

  const { control, setValue, watch, handleSubmit, reset, getValues } = useForm({
    defaultValues: {
      permissions: [],
    },
  });

  const checkedPermissions = watch("permissions");

  const fetchActions = async () => {
    try {
      setIsLoading(true);
      const response = await permissionAPIWithErrorHandling.getListAllPermission();

      if (response.data.success && response.data.data) {
        message.success("Truy xuất thông tin quyền thành công!")
        setListPermission(response.data.data);
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error.response?.data?.message || "Lỗi không xác định",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDetail = async () => {
    try {
      setIsLoading(true);
      const response = await permissionAPIWithErrorHandling.getPermissionByUserId(id);
      if (response.data?.data && response.status === 200) {
        setDataDetail(response.data.data);
        setValue("permissions", response.data.data.all_permissions);
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error.response?.data?.message || "Lỗi không xác định",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchActions();
    fetchDetail();
  }, []);

  const handleChangeGroup = (group, checked) => {
    let current = [...checkedPermissions];

    // 1. Xử lý thằng cha
    const isGroupExist = current.some((p) => p.id === group.id);
    if (checked && !isGroupExist) {
      current.push(group);
    } else if (!checked && isGroupExist) {
      current = current.filter((p) => p.id !== group.id);
    }

    // 2. Xử lý thằng con
    if (group.children && group.children.length > 0) {
      group.children.forEach((child) => {
        const isChildExist = current.some((p) => p.id === child.id);
        if (checked && !isChildExist) {
          current.push(child);
        } else if (!checked && isChildExist) {
          current = current.filter((p) => p.id !== child.id);
        }
      });
    }

    setValue("permissions", current);
  };

  const handleChangeItem = (item, checked) => {
    let current = [...checkedPermissions];
    const isExist = current.some((p) => p.id === item.id);

    const isGroup = !!item.children; // item là group nếu có children

    if (checked) {
      // ✅ Nếu được chọn và chưa có thì thêm vào
      if (!isExist) {
        current.push(item);
      }

      if (!isGroup) {
        // Nếu là con thì thêm cha nếu chưa có
        const group = listPermission.find((g) =>
          g.children?.some((c) => c.id === item.id)
        );

        if (group) {
          const isGroupIn = current.some((p) => p.id === group.id);
          if (!isGroupIn) {
            current.push(group);
          }
        }
      }
    } else {
      // ❌ Nếu bị bỏ chọn
      current = current.filter((p) => p.id !== item.id);

      if (isGroup) {
        // Nếu bỏ chọn là cha → bỏ hết con
        const childIds = item.children.map((c) => c.id);
        current = current.filter((p) => !childIds.includes(p.id));
      } else {
        // Nếu bỏ chọn là con → kiểm tra xem còn con nào được chọn không
        const group = listPermission.find((g) =>
          g.children?.some((c) => c.id === item.id)
        );

        if (group) {
          const hasOtherChecked = group.children.some((c) =>
            current.some((p) => p.id === c.id)
          );

          if (!hasOtherChecked) {
            current = current.filter((p) => p.id !== group.id);
          }
        }
      }
    }

    setValue("permissions", current);
  };

  const handleCheckAll = () => {
    const allPermissions = [];

    listPermission.forEach((group) => {
      allPermissions.push(group); // push cả object group
      if (group.children?.length) {
        allPermissions.push(...group.children); // push cả object child
      }
    });

    setValue("permissions", allPermissions);
  };

  const handleUncheckAll = () => {
    setValue("permissions", []);
  };

  const isAllChecked = () => {
    const allPermissionIds = [];

    listPermission.forEach((group) => {
      if (!group.children?.length) {
        allPermissionIds.push(group.id);
      } else {
        allPermissionIds.push(...group.children.map((c) => c.id));
      }
    });

    const selectedIds = checkedPermissions.map((p) => p.id);
    return allPermissionIds.every((id) => selectedIds.includes(id));
  };

  const isGroupChecked = (group) => {
    if (!group.children || group.children.length === 0) {
      return checkedPermissions.some((p) => p.id === group.id);
    }
    return group.children.every((child) =>
      checkedPermissions.some((p) => p.id === child.id)
    );
  };

  const onSubmit = async (data) => {
    const selectedPermissionIds = data.permissions.map((p) => p.id);

    if (selectedPermissionIds.length === 0) {
      notify.error({
        message: "Lỗi",
        description: "Bạn chưa chọn quyền nào.",
      });
      return;
    }

    try {
      const permissionData = {
        user_id: id,
        permission_ids: selectedPermissionIds,
      };
      
      const response = await permissionAPIWithErrorHandling.assignToUser(permissionData);

      if (response.data) {
        notify.success({
          message: "Thành công",
          description: "Bạn đã thêm quyền vào tài khoản thành công!",
        });
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error.message || "Lỗi không xác định",
      });
      console.error('Error:', error);
    }
  };

  return (
    
    <div className="bg-gray-50 min-h-screen p-6">
      <Card className="shadow-sm">
        <div className="mb-6">
          <Breadcrumb separator=">">
            <Breadcrumb.Item>
              <NavLink to="/list-account">Quản lý tài khoản</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <NavLink to={`/add-permission/${id}`}>Danh sách quyền</NavLink>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

      <div style={{}}>
        <Card title="Thông tin chung người dùng" style={{ marginBottom: 20 }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={8}>
              <div>
                <strong>Người dùng: </strong>
                {dataDetail?.user.username}
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div>
                <strong>Chức vụ: </strong>
                {/* {dataDetail?.user.info.type === 'SHOP' ? 'Chủ tài khoản' : dataDetail?.user.info.type === 'BRANCH_MANAGER' ? 'Quản lý' : 'Nhân viên'} */}
                {
                  dataDetail?.user.info.type === "SHOP"
                    ? "Chủ tài khoản"
                    : dataDetail?.user.info.type === "WARD_LEADER"
                    ? "Quản lý cấp phường"
                    : dataDetail?.user.info.type === "BRANCH_MANAGER"
                    ? "Quản lý"
                    : "Nhân viên"
                }
              </div>
            </Col>
            <Col xs={24} sm={8}>
              <div>
                <strong>Giới tính: </strong>
                {dataDetail?.user.info.gender === "MALE"
                  ? "Nam"
                  : dataDetail?.user.info.gender === "FEMALE"
                  ? "Nữ"
                  : dataDetail?.user.info.gender === "OTHER"
                  ? "Khác"
                  : ""}
              </div>
            </Col>
          </Row>
        </Card>

        <Row
          gutter={[16, 16]}
          style={{
            marginBottom: 20,
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <Button
            danger
            onClick={isAllChecked() ? handleUncheckAll : handleCheckAll}
          >
            {isAllChecked() ? "Bỏ chọn tất cả" : "Chọn tất cả"}
          </Button>
          <Button type="primary" onClick={handleSubmit(onSubmit)}>
            Lưu phân quyền
          </Button>
        </Row>

        <Row gutter={[16, 16]}>
          <Controller
            name="permissions"
            control={control}
            render={() =>
              listPermission.map((group) => (
                <Col
                  key={group.id}
                  xs={24}
                  sm={12}
                  md={8}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Card
                    bordered
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                    bodyStyle={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontWeight: 600,
                        marginBottom: 10,
                      }}
                    >
                      <span>{group.label}</span>
                      <Checkbox
                        checked={isGroupChecked(group)}
                        indeterminate={
                          group.children?.length > 0 &&
                          group.children.some((child) =>
                            checkedPermissions.some((p) => p.id === child.id)
                          ) &&
                          !isGroupChecked(group)
                        }
                        onChange={(e) =>
                          handleChangeGroup(group, e.target.checked)
                        }
                      />
                    </div>

                    <div style={{ flex: 1 }}>
                      {group.children?.map((child) => (
                        <div
                          key={child.id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 8,
                            paddingLeft: 10,
                          }}
                        >
                          <span>{child.label}</span>
                          <Checkbox
                            checked={checkedPermissions.some(
                              (p) => p.id === child.id
                            )}
                            onChange={(e) =>
                              handleChangeItem(child, e.target.checked)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </Card>
                </Col>
              ))
            }
          />
        </Row>
      </div>
      </Card>
    </div>
  );
};

export default AddPermissionInUser;
